var render = function render(_c, _vm) {
  return _c("span", [_vm._m(0), _vm._v(_vm._s(_vm.props.name) + " ")])
}
var staticRenderFns = [
  function(_c, _vm) {
    return _c("span", { staticClass: "red--text" }, [
      _c("strong", [_vm._v("* ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }